export default "__VITE_ASSET__PoMIM_Mi__"